const features = [
  {
    icon: 'ri-search-eye-line',
    title: '深度调查',
    desc: '每一篇爆料都经过专业团队的深入调查和多源交叉验证，确保信息准确可靠，不做标题党，不传假消息。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '实时追踪',
    desc: '覆盖全网热点，7x24小时不间断追踪，第一时间为您呈现娱乐圈的最新动态和幕后真相。',
  },
  {
    icon: 'ri-shield-star-line',
    title: '独家信源',
    desc: '拥有覆盖娱乐圈各领域的独家信息网络，包括艺人工作室内部线人、资深媒体人等行业资源。',
  },
  {
    icon: 'ri-emotion-happy-line',
    title: '读者至上',
    desc: '一切内容以读者需求为导向，不吃人血馒头，不恶意炒作，用理性和温度还原事件真相。',
  },
];

export default function WhyChooseUs() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 mb-4 text-xs font-label font-semibold text-secondary-600 bg-secondary-100 rounded-full">
            为什么选择我们
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900 mb-3">
            吃瓜，我们是专业的
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            六年深耕娱乐八卦领域，我们建立起了一套完整的资讯生产体系
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-lg border border-background-200/70 p-5 md:p-6 text-center group transition-all duration-300"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-4 rounded-full bg-accent-100 flex items-center justify-center group-hover:bg-accent-200 transition-colors duration-300">
                <i className={`${feature.icon} text-2xl md:text-3xl text-accent-600`}></i>
              </div>
              <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}